import araSyncLogoReverse from '../../assets/AraSync-Solid-Core-Stacked-Reverse.svg';
import LoginBackdrop from './LoginBackdrop';
import LoginMotif from './LoginMotif';

/**
 * Branding side of the sign-in pages (staff and patient portal): the logo over a
 * soft glow, with the care-team film. Shown on wide screens only.
 */
export default function LoginBrandPanel() {
  return (
    <div className="hidden lg:flex lg:flex-1 relative overflow-hidden">
      <LoginBackdrop />
      <img
        src={araSyncLogoReverse}
        alt="AraSync Health Systems — Systems That Put People First"
        className="absolute left-10 top-10 z-10 h-auto w-44 max-w-full"
      />
      <LoginMotif />
    </div>
  );
}
